import type { ResolvedPrivacyTexts } from '../../utils/privacy'
import styles from './PrivacyGate.module.css'

interface Props {
  texts: ResolvedPrivacyTexts
  onAccept: () => void
}

function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 2 4 5v6c0 5 3.4 8.6 8 11 4.6-2.4 8-6 8-11V5l-8-3Z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  )
}

export default function PrivacyGate({ texts, onAccept }: Props) {
  return (
    <div className={styles.gate} data-part="gate" role="group" aria-labelledby="n8n-chatbot-gate-title">
      <div className={styles.body}>
        <div className={styles.iconWrap} data-part="gate-icon" aria-hidden="true">
          <ShieldIcon />
        </div>
        <h3 className={styles.title} id="n8n-chatbot-gate-title" data-part="gate-title">{texts.title}</h3>
        <p className={styles.intro} data-part="gate-intro">{texts.intro}</p>
        <p className={styles.note} data-part="gate-note">{texts.sensitiveDataNote}</p>
        {texts.privacyPolicyUrl && (
          <a
            className={styles.link}
            data-part="gate-link"
            href={texts.privacyPolicyUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {texts.privacyLinkText}
          </a>
        )}
      </div>
      <button type="button" className={styles.acceptBtn} data-part="gate-accept" onClick={onAccept}>
        {texts.acceptButton}
      </button>
    </div>
  )
}
